// Cardmarket-Produktadressen (V-Nummer + Expansion) für print-gelockte Karten.
// Nur bei geöffnetem Export-Modal und nur für die gelockten IDs — Ergebnis lange cachebar
// (ändert sich nur durch Bulk-Import/Set-Sync).
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/apiClient';

export default function useCardmarketRefs(ids = [], enabled = true) {
  const sorted = [...new Set(ids)].sort();
  return useQuery({
    queryKey: ['cardmarketRefs', sorted.join(',')],
    queryFn: async () => {
      const { data } = await apiClient.post('/api/cards/cardmarket-refs', { ids: sorted });
      return data;
    },
    staleTime: 1000 * 60 * 60,
    enabled: enabled && sorted.length > 0,
  });
}
